(function () {
  'use strict';

  function getRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  }

  function normalizeRoot(root) {
    return root.endsWith('/') ? root : root + '/';
  }

  function parsePrice(value) {
    if (value === undefined || value === null) return 0;
    var cleaned = String(value).replace(/\s/g, '').replace(/[^\d.,-]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    else cleaned = cleaned.replace(',', '.');
    var parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getUrlParam(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  function eventId(prefix) {
    return [prefix || 'lp', Date.now(), Math.random().toString(16).slice(2)].join('_');
  }

  function setLoading(isLoading) {
    document.querySelectorAll('[data-lp-direct-checkout]').forEach(function (btn) {
      btn.disabled = !!isLoading;
      btn.classList.toggle('is-loading', !!isLoading);
      if (isLoading) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    });
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload || {})
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || res.statusText || 'Request failed');
        });
      }
      return res.json().catch(function () { return {}; });
    });
  }

  function selectedQuantity(scope) {
    var root = scope && scope.closest ? scope.closest('.eo-lp') : document;
    var checked = root ? root.querySelector('[data-lp-quantity-option]:checked') : null;
    var qty = checked ? Number(checked.value) : 1;
    if (![1, 2, 3].includes(qty)) qty = 1;
    return qty;
  }

  function payloadFromButton(button) {
    var quantity = selectedQuantity(button);
    return {
      variantId: button.dataset.variantId || '',
      productId: button.dataset.productId || '',
      productTitle: button.dataset.productTitle || 'Produs LP',
      productPrice: parsePrice(button.dataset.productPrice || 0),
      quantity: quantity,
      currency: button.dataset.currency || 'RON',
      discountCode: button.dataset.discountCode || '',
      clearCart: button.dataset.clearCart !== 'false'
    };
  }

  function metaTrack(name, payload, id) {
    if (typeof window.fbq !== 'function') return;
    try { window.fbq('track', name, payload || {}, id ? { eventID: id } : undefined); }
    catch (e) { console.warn('LP Meta tracking error:', e); }
  }

  function dataLayerTrack(name, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ecommerce: ecommerce || {} });
    } catch (e) { console.warn('LP dataLayer tracking error:', e); }
  }

  function trackAddToCart(data, id) {
    var total = data.productPrice * data.quantity;
    var item = { item_id: String(data.variantId), item_name: data.productTitle, quantity: data.quantity, price: data.productPrice };
    metaTrack('AddToCart', { content_name: data.productTitle, content_ids: [String(data.variantId)], content_type: 'product', value: total, currency: data.currency, num_items: data.quantity }, id);
    dataLayerTrack('add_to_cart', { currency: data.currency, value: total, items: [item] });
  }

  function trackBeginCheckout(data, id) {
    var total = data.productPrice * data.quantity;
    var item = { item_id: String(data.variantId), item_name: data.productTitle, quantity: data.quantity, price: data.productPrice };
    metaTrack('InitiateCheckout', { content_name: data.productTitle, content_ids: [String(data.variantId)], content_type: 'product', value: total, currency: data.currency, num_items: data.quantity }, id);
    dataLayerTrack('begin_checkout', { currency: data.currency, value: total, items: [item] });
  }

  function redirectToCheckout(root, discountCode) {
    if (discountCode) window.location.href = root + 'discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout';
    else window.location.href = root + 'checkout';
  }

  async function directCheckout(button) {
    var data = payloadFromButton(button);
    if (!data.variantId || Number(data.variantId) <= 0) {
      alert('Produsul nu este disponibil momentan. Selectează un produs valid în Theme Editor.');
      return;
    }

    var root = normalizeRoot(getRoot());
    var id = eventId('lp_checkout');
    setLoading(true);

    try {
      if (data.clearCart) await postJson(root + 'cart/clear.js', {});
      await postJson(root + 'cart/add.js', { items: [{ id: Number(data.variantId), quantity: data.quantity, properties: { '_LP Page': window.location.pathname, '_LP Product': data.productTitle, '_LP Quantity': String(data.quantity), '_LP Event ID': id } }] });
      await postJson(root + 'cart/update.js', { attributes: { lp_page: window.location.pathname, lp_product: data.productTitle, lp_variant_id: data.variantId, lp_quantity: String(data.quantity), lp_event_id: id, utm_source: getUrlParam('utm_source'), utm_medium: getUrlParam('utm_medium'), utm_campaign: getUrlParam('utm_campaign'), utm_content: getUrlParam('utm_content'), utm_term: getUrlParam('utm_term'), fbclid: getUrlParam('fbclid'), gclid: getUrlParam('gclid') } });
      trackAddToCart(data, id);
      trackBeginCheckout(data, id);
      setTimeout(function () { redirectToCheckout(root, data.discountCode); }, 180);
    } catch (e) {
      console.error('LP checkout error:', e);
      alert(e.message || 'A apărut o problemă. Te rugăm să încerci din nou.');
      setLoading(false);
    }
  }

  function initQuantitySelector() {
    document.querySelectorAll('[data-lp-quantity-selector]').forEach(function (selector) {
      var options = selector.querySelectorAll('[data-lp-quantity-option]');
      function sync() {
        options.forEach(function (input) {
          var card = input.closest('[data-lp-quantity-card]');
          if (card) card.classList.toggle('is-active', input.checked);
        });
        var section = selector.closest('.eo-lp');
        if (!section) return;
        var qty = selectedQuantity(selector);
        section.querySelectorAll('[data-lp-sticky-qty]').forEach(function (el) {
          el.textContent = 'x' + qty;
        });
      }
      options.forEach(function (input) {
        input.addEventListener('change', sync);
      });
      sync();
    });
  }


  function scrollToQuantity() {
    var target = document.querySelector('[data-lp-quantity-selector]') || document.querySelector('#formular-comanda');
    if (!target) return;
    var offset = 18;
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    setTimeout(function () {
      var firstOption = target.querySelector('[data-lp-quantity-option]');
      if (firstOption && typeof firstOption.focus === 'function') firstOption.focus({ preventScroll: true });
    }, 420);
  }

  function initScrollButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lp-scroll-qty]');
      if (!button) return;
      event.preventDefault();
      scrollToQuantity();
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-lp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var section = thumb.closest('.eo-lp');
        if (!section) return;
        var mainImage = section.querySelector('.eo-lp-main-image');
        var newImage = thumb.dataset.image;
        if (!mainImage || !newImage) return;
        mainImage.src = newImage;
        section.querySelectorAll('[data-lp-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initViewTracking() {
    var data = window.EO_LP_DATA || {};
    if (!data.variant_id) return;
    var id = eventId('lp_view');
    var price = parsePrice(data.price || 0);
    metaTrack('ViewContent', { content_name: data.product_title || 'Produs LP', content_ids: [String(data.variant_id)], content_type: 'product', value: price, currency: data.currency || 'RON' }, id);
    dataLayerTrack('view_item', { currency: data.currency || 'RON', value: price, items: [{ item_id: String(data.variant_id), item_name: data.product_title || 'Produs LP', quantity: 1, price: price }] });
  }

  function initButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lp-direct-checkout]');
      if (!button) return;
      event.preventDefault();
      directCheckout(button);
    });
  }



  function initFaqAnimations() {
    document.querySelectorAll('.eo-faq-item').forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        var wrap = item.closest('.eo-faq-wrap');
        if (!wrap || !wrap.hasAttribute('data-one-open')) return;

        wrap.querySelectorAll('.eo-faq-item[open]').forEach(function (openItem) {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      });
    });
  }

  function initRevealAnimations() {
    var items = document.querySelectorAll('.eo-reveal, .eo-animate-card');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el, index) {
      el.style.setProperty('--eo-delay', (index % 6) * 90 + 'ms');
      observer.observe(el);
    });
  }

  function init() {
    initQuantitySelector();
    initGallery();
    initButtons();
    initScrollButtons();
    initFaqAnimations();
    initRevealAnimations();
    initViewTracking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
